import { Link } from "react-router-dom";
import { FooterBlock, FooterInfo, FooterPrivacyLink } from "./styled";
import Typography from "../Typography";
import { ReactComponent as Chevron } from "../../assets/icon/chevron-down.svg";

export const Footer = () => {
  return (
    <FooterBlock>
      <FooterPrivacyLink as={Link} to="/policy-privacy">
        <Typography color="whiteSecondary" semibold>
          Политика конфиденциальности
        </Typography>
        <Chevron width={24} height={24} />
      </FooterPrivacyLink>
      <FooterInfo>
        <Typography as="p" color="whiteSecondary" s>
          <Typography as="span">Адрес: </Typography>Ростов-на-Дону,
          пр.&nbsp;Нагибина&nbsp;3А, оф.&nbsp;
          <span style={{ whiteSpace: "nowrap" }}>2-805а</span>
        </Typography>
        <Typography as="p" color="whiteSecondary">
          <Typography as="span">ИНН: </Typography>6163087640
        </Typography>
        <Typography as="p" color="whiteSecondary">
          <Typography as="span">Почта: </Typography>
          <a href="mailto:alena@itradio.net">alena@itradio.net</a>
        </Typography>
        <Typography
          as="p"
          color="whiteSecondary"
        >{`ООО "Южный Регион МЕДИА"`}</Typography>
      </FooterInfo>
    </FooterBlock>
  );
};
